import React from 'react'
import { FaFacebook, FaInstagram, FaLinkedin } from 'react-icons/fa';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <>
    <footer className="footer">
        <div className="footer-copyright text-center py-2 d-flex justify-content-between px-3">
            <a href="https://www.vu.edu.pk/"> VU Software House</a>
            {currentYear}
            Copyright: un&copy
            <div className="links">
            <div className="links">
          <FaFacebook className="fa-lg mx-2" />
          <FaInstagram className="fa-lg mx-2" />
          <FaLinkedin className="fa-lg mx-2" />
        </div>
            </div>
        </div>

    </footer>
    </>
  )
}

export default Footer

